import { default as Rule } from './Rule';

export default Rule;
